import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import XMLViewer from 'react-xml-viewer';
import { pepAndSanctionsXml } from 'src_server/types';
import { WrongIconWrapper, XmlDetailsWrapper, XmlDetailsSection, XmlDetailsTitle } from './PepXml.style';
import { PepXmlState } from './PepXmlState';
import { useAppStateContext } from 'src/AppState/AppState';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

const renderXml = (xmlData: pepAndSanctionsXml.TResponseType | null): React.ReactElement<string, string> => {
    if (xmlData?.responseStatus === 'success') {
        const xmlResponse = xmlData.data.xmlResponses[0];
        if (xmlResponse === undefined) {
            return <div>No XML data available</div>;
        }
        return (
            <div>
                <XMLViewer xml={xmlResponse} />
            </div>
        );
    }

    if (xmlData?.responseStatus === 'error') {
        return <div>{xmlData.data.error.message}</div>;
    }

    return <div>``</div>;
};

interface PropsType {
    closeModal: () => void;
    accountId: number | null;
}
export const PepXmlWrapper = observer('AuditAffordability', (props: PropsType) => {
    const { common } = useAppStateContext();
    const [state] = useState(new PepXmlState(common.trpcClient, () => props.accountId));

    return (
        <div className='audits visible'>
            <Loader isActive={state.isLoading} />
            <div className='audits-content'>
                <WrongIconWrapper
                    onClick={props.closeModal}
                    dataTest='pep-xml-close-modal-icon'
                />
                <XmlDetailsWrapper data-test='pep-xml-details'>
                    <XmlDetailsSection>
                        <XmlDetailsTitle>XML details</XmlDetailsTitle>
                        {renderXml(state.xmlData)}
                    </XmlDetailsSection>
                </XmlDetailsWrapper>
            </div>
        </div>
    );
});

export const PepXmlRouterWrapper = observer('PepXmlRouterWrapper', () => {
    const { routerBackoffice } = useAppStateContext();
    const isOpened = routerBackoffice.getParametersString('customers', 'xml-data') !== null;
    const accountId = routerBackoffice.getParameter('customers', 'xml-data');
    const convertedAccountId: number | null = accountId === null ? null : parseInt(accountId, 10);

    const onClick = (): void => {
        routerBackoffice.removeParamInNamespace('customers', 'xml-data');
    };

    return isOpened ? (
        <PepXmlWrapper
            closeModal={onClick}
            accountId={convertedAccountId}
        />
    ) : null;
});
